export default __webpack_public_path__ + "static/media/file.ee677a90.svg";